import React, { useState } from "react";
import classnames from "classnames";
import { useNavigate, useParams } from "react-router";
import { ConsultModal } from "../../components/ConsultModal";
import { useTranslation } from "react-i18next";
import "./styles.less";
import { Button } from "../../components/Button";

export const SolutionDetailBanner = (props) => {
  const { title, sub } = props;
  const { type } = useParams();
  const [visible, setVisible] = useState(false);
  const nav = useNavigate();
  const { t } = useTranslation();

  const gotoDetail = (key) => {
    nav(`/solutions/${key}`);
  };
  const navList = [
    {
      key: "medical",
      label: `${t("solution.detail.label-medical")}`,
      icon: "icon authing-icon authing-medical",
    },
    {
      key: "government",
      label: `${t("solution.detail.label-government")}`,
      icon: "icon authing-icon authing-zhengfu",
    },
    {
      key: "education",
      label: `${t("solution.detail.label-education")}`,
      icon: "icon authing-icon authing-education",
    },
    {
      key: "finance",
      label: `${t("solution.detail.label-finance")}`,
      icon: "icon authing-icon authing-jinrong",
    },
    {
      key: "game",
      label: `${t("solution.detail.label-game")}`,
      icon: "icon authing-icon authing-game1",
    },
    {
      key: "software",
      label: `${t("solution.detail.label-software")}`,
      icon: "icon authing-icon authing-software",
    },
    {
      key: "publisher",
      label: `${t("solution.detail.label-publisher")}`,
      icon: "icon authing-icon authing-chubanshe",
    },
    // {
    //   key: "enterprise",
    //   label: `${t("solution.detail.label-enterprise")}`,
    //   icon: "icon authing-icon authing-chubanshe",
    // },
  ];

  return (
    <div>
      <section className="solution-detail">
        <div className="solution-banner-detail-warp">
          <div className="solution-banner">
            <div className="banner-text">
              <div className="title">{title}</div>
              <div className="subtitle">{sub}</div>
              <Button
                className="solution-button"
                onClick={() => {
                  window.open("https://www.authing.cn/authingform");
                }}
              >
                {t("solution.detail.button-consult")}
              </Button>
            </div>
          </div>
        </div>

        <div className="solution-type">
          {navList.map((nav, index) => {
            const cls = classnames({
              item: true,
              selected: type === nav.key,
            });
            return (
              <div
                key={index}
                className={cls}
                onClick={() => gotoDetail(nav.key)}
              >
                <div className="item-icon">
                  <i className={nav.icon}></i>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
};
